/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Property } from "../../property/types/Property";
export const DestinationField = core.serialization.object({
    destinationField: Property,
    preview: core.serialization.list(core.serialization.string()).optional(),
});
